import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./ressources/fonts/_fonts.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import InstallPopup from "./installPopup.js";

// Enregistrement du Service Worker
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      console.log("Service Worker enregistré avec succès:", registration);
    })
    .catch((error) => {
      console.error(
        "Erreur lors de l'enregistrement du Service Worker:",
        error
      );
    });
}

// Initialisation de React
const rootElement = document.getElementById("root");

localStorage.setItem("VERSION:", process.env.REACT_APP_CARBOPARC_VERSION);

// Vérifie si l'élément root existe
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <BrowserRouter basename="/">
      <App />
      <InstallPopup />
    </BrowserRouter>
  );
} else {
  console.error("Élément root non trouvé dans le DOM.");
}

// Mesures de performance (optionnel)
reportWebVitals(console.log);
